import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-292832a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-top-section"
}

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseForm',
  props: {
    isLoading: { type: Boolean },
    error: {}
  },
  emits: ['submit', 'reset'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const form = ref<HTMLElement | undefined>();

const handleSubmit = () => {
  emit('submit');
};

const resetForm = () => {
  emit('reset');
};

onMounted(() => {
  resetForm();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    ref_key: "form",
    ref: form,
    class: _normalizeClass([{
      loading: _ctx.isLoading,
    }, "ui form base-form-container"]),
    novalidate: "",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 34))
}
}

})